module.exports = new Promise((resolve, reject) => {
		window["_paperco_mfe_resolver_teaching-assets"] = { resolve, reject };
		const script = document.createElement("script");
		script.type = "module";
		script.async = true;
		script.innerHTML = `
			import("https://teaching-assets-web.paperstg.co/assets/remoteEntry.mjs")
				.then(remoteEntry => window["_paperco_mfe_resolver_teaching-assets"].resolve(remoteEntry))
				.catch(() => window["_paperco_mfe_resolver_teaching-assets"].reject("Failed to import _paperco_mfe_resolver_teaching-assets"));
		`
		document.head.appendChild(script);
	});